import { getTestAttributes } from '@chillibean/component-library';
import { NavLink, useParams } from 'react-router-dom';

export function FormTemplateNavBar() {
  const { templateId } = useParams();

  return (
    <ul id="template-builder_navbar" {...getTestAttributes('template-builder-navbar')}>
      <li>
        <NavLink activeClassName="active" to={`/${templateId}/edit`}>
          Edit Form
        </NavLink>
      </li>
      <li>
        <NavLink activeClassName="active" to={`/${templateId}/workflows`}>
          Workflows
        </NavLink>
      </li>
      <li>
        <NavLink activeClassName="active" to={`/${templateId}/trial_containers`}>
          Libraries
        </NavLink>
      </li>
      <li>
        <NavLink activeClassName="active" to={`/${templateId}/versions`}>
          Versions
        </NavLink>
      </li>
    </ul>
  );
}

export default FormTemplateNavBar;
